import React, { useEffect } from 'react'
import { Modal, Row, Col, Flex, App, Button, Space} from 'antd'
import { useState } from 'react'    
import classes from './invoice.module.css'
import { useKaipiaodanUpdateQuery, useKPSQchaosongMutation, useKaipiaodanZTXGMutation } from '../../store/DianShangYeWuApi'
import InvoiceNodeCheck from './InvoiceNodeCheck'
import Asterisk from '../../cpn/Asterisk'
import DocumentRule from '../../cpn/DocumentRule'
import Icon from '../../cpn/Icon'
import StateTag from '../../cpn/StateTag'
import ReportCheck from '../../document/report/ReportCheck'
import { usePrintModal } from '../../cpn/usePrintModal'
import InvoiceUpload from './InvoiceUpload'
import FilePreview from '../../cpn/FilePreview'
import InvoiceFinanceWithdraw from './InvoiceFinanceWithdraw'
import InvoiceFinanceAmount from './InvoiceFinanceAmount'
function InvoiceCheck(props) {  
    const yh_qx = props.yh_qx || '';
    const { message } = App.useApp();
    const [openCheck, setOpenCheck] = useState(false)
    const { handlePrint, modalRef } = usePrintModal(openCheck, '开票申请')
    const [info, setInfo] = useState({
        kpsq_content: '',
        kpsq_ctime: '',
        kpsq_price: '',
        kpsq_uname: '',
        kpsq_num: '',
        kpsq_type_id: '',
        kpsq_type_name: '',
        kpsq_kh_id: '',
        kpsq_kh_name: '',
        kpsq_amount: '',
        kpsq_date: '',
        kpsq_date_end: '',
        kpsq_bzd_name: '',
        kpsq_bzd_danhao: '',
        kpsq_id: '',
        kpsq_yuedu: '',
        kpsq_state: '',
        kpsq_uid: '',
        kpsq_bzd_id: '',
        kpsq_month: '',
        kpsq_year: '',
        kpsq_state_time: '',
        kpsq_fp_file: '',
        kpsq_fp_name: '',
        kpsq_cw_content: '',
    })
    const { data, isSuccess } = useKaipiaodanUpdateQuery({ kpsq_id: props.kpsq_id }, { skip: !openCheck, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            setInfo(prev=>({...prev,
                kpsq_content: data.Result.kpsq_content,
                kpsq_ctime: data.Result.kpsq_ctime,
                kpsq_price: data.Result.kpsq_price,
                kpsq_uname: data.Result.kpsq_uname,
                kpsq_num: data.Result.kpsq_num,
                kpsq_type_id: data.Result.kpsq_type_id,
                kpsq_type_name: data.Result.kpsq_type_name,
                kpsq_kh_name: data.Result.kpsq_kh_name,
                kpsq_kh_id: data.Result.kpsq_kh_id,                
                kpsq_amount: data.Result.kpsq_amount,
                kpsq_date: data.Result.kpsq_date,
                kpsq_date_end: data.Result.kpsq_date_end,
                kpsq_bzd_name: data.Result.kpsq_bzd_name,
                kpsq_bzd_danhao: data.Result.kpsq_bzd_danhao,
                kpsq_id: data.Result.kpsq_id,
                kpsq_yuedu: data.Result.kpsq_yuedu,
                kpsq_state: data.Result.kpsq_state,
                kpsq_uid: data.Result.kpsq_uid,
                kpsq_bzd_id: data.Result.kpsq_bzd_id,
                kpsq_month: data.Result.kpsq_month,
                kpsq_year: data.Result.kpsq_year,
                kpsq_state_time: data.Result.kpsq_state_time,
                kpsq_image_file: data.Result.kpsq_image_file,
                kpsq_image_name: data.Result.kpsq_image_name,
                kpsq_bm_name: data.Result.kpsq_bm_name,
                kpsq_bm_id: data.Result.kpsq_bm_id,
                kpsq_khyhzh_name: data.Result.kpsq_khyhzh_name,
                kpsq_khyhzh_id: data.Result.kpsq_khyhzh_id,
                kpsq_ddsr_id: data.Result.kpsq_ddsr_id,
                kpsq_name: data.Result.kpsq_name,
                kpsq_khfpxx_name: data.Result.kpsq_khfpxx_name,
                kpsq_khfpxx_id: data.Result.kpsq_khfpxx_id,
                kpsq_fp_file: data.Result.kpsq_fp_file,
                kpsq_fp_name: data.Result.kpsq_fp_name,
                kpsq_cw_content: data.Result.kpsq_cw_content,
            }))
        }
    }, [data, isSuccess])
    //取消提交
    // const [ztxg] = useJiekuanZTXGMutation()
    // const [isSubmitting, setIsSubmitting] = useState(false)
    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '0.00';
        return `￥${Number(value).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
    //抄送
    const [kpsqChaosong] = useKPSQchaosongMutation()
    //取消提交
    const [ztxg] = useKaipiaodanZTXGMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
           <a 
                type='check' 
                onClick={() => { 
                    if(props.kpsq_sp_state==='2' && props.kpsq_sp_jd_name==='抄送'){
                        kpsqChaosong({
                            'kpsq_sp_id': props.kpsq_sp_id,     //抄送节点id
                            'kpsq_id': props.kpsq_id,
                            'kpsq_sp_yh_id': props.kpsq_sp_yh_id   //抄送人id
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('抄送成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('抄送失败'+res.data.Message)
                            }
                        })
                    }else if(props.kpsq_state === '5' && props.kpsq_uid === props.yh_id){
                        ztxg({
                            kpsq_id:props.kpsq_id,
                            kpsq_state: '6',
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('已读标记成功')  
                                setOpenCheck(true);  
                            }else{
                                message.error('已读标记失败'+res.data.Message)
                            }
                        })
                    }else{
                        setOpenCheck(true);  
                    }
                }} 
            >
                {(props.kpsq_sp_state==='2' && props.kpsq_sp_jd_name==='抄送')&&<span style={{color:"red"}}>未读：</span>}
                {(props.kpsq_state==='5' && props.kpsq_uid === props.yh_id && props.listType === 'submitted')&&<span style={{color:"red"}}>未读：</span>}
                {props.kpsq_state==='4'&&<span style={{color:"red"}}>已驳回：</span>}
                {props.kpsq_sp_kpsq_kh_name?props.kpsq_sp_kpsq_kh_name:props.kpsq_kh_name}
            </a>
            <Modal
                open={openCheck}
                onCancel={() => setOpenCheck(false)}
                onOk={() => setOpenCheck(false)}
                width={1330}
                footer={[
                    <Button key="print" type="primary" onClick={handlePrint}>
                        打印
                    </Button>,
                    <Button key="close" onClick={() => setOpenCheck(false)}>
                        关闭
                    </Button>
                ]}
            >
                <div ref={modalRef}>
                 <Row style={{width:"1280px"}}>
                    {(info.kpsq_state === '5' || info.kpsq_state==='6') && <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}>
                        <img src={'./img/invoiceFinished.png'} alt="开票申请" width={150} height={150}/>
                    </div>} 
                    <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #FF6600',borderLeft:'3px solid #FF6600'}}></Col>
                    <Col span={16} className={classes.row_top_middle} style={{color:'#FF6600',borderTop:'3px solid #FF6600'}}>开票申请</Col>
                    <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #FF6600',borderRight:'3px solid #FF6600'}}></Col>
                        {/* 第一行 */}
                    <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #FF6600',color:'#FF6600'}}><Asterisk color='red'/> 团队名称</Col>
                    <Col span={6}  className={classes.col_top_input}>
                        {info.kpsq_bzd_id === '无' ? null : <ReportCheck dsbzd_id={info.kpsq_bzd_id} dsbzd_name={info.kpsq_bzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />}
                    </Col>  
                    <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 开票金额</Col>   
                    <Col span={6}  className={classes.col_top_input}>
                        {formatCurrency(info.kpsq_amount)}
                    </Col>  
                    <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                    <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #FF6600'}}>
                        {info.kpsq_bm_name}
                    </Col> 
                    
                    {/* 第二行 */}

                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}><Asterisk color='red'/> 客户</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                       {info.kpsq_kh_name}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 开票信息</Col>
                    <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #FF6600'}}>
                        {info.kpsq_khfpxx_name}
                    </Col>
                    {/* 第三行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}><Asterisk color='red'/> 开票项目</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                       {info.kpsq_name}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 发票类型</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {info.kpsq_type_name}
                    </Col> 
                    <Col span={2} className={classes.col_middle_label}>备注</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #FF6600'}}>
                        {info.kpsq_content}
                    </Col> 
                    {/* 第四行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}>附件</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <Flex wrap="wrap" gap="10px">
                            {info.kpsq_image_file && info.kpsq_image_name ? info.kpsq_image_file.map((fileName, index) => {
                                const imageName = info.kpsq_image_name[index];
                                return (
                                    <a
                                        key={index}
                                        href={`http://dianshangtaizhang.zzddww.com/assets/images/application/${imageName}`}
                                        target="_blank"
                                        rel="noopener noreferrer"                                    
                                    >
                                        {fileName}
                                    </a>
                                );
                            }) : null}
                        </Flex>
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}>编号 / 状态</Col>
                    <Col span={6}  className={classes.col_middle_input} >
                        {props.kpsq_id}&emsp;<StateTag state={info.kpsq_state} />
                    </Col> 
                    <Col span={2} className={classes.col_middle_label}>发票下载</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{display:'flex',alignItems:'center',justifyContent:'left',borderRight:'3px solid #FF6600'}}>
                        <InvoiceUpload 
                            kpsq_id={props.kpsq_id}
                            kpsq_name={info.kpsq_name}
                            kpsq_type_name={info.kpsq_type_name}
                            kpsq_kh_name={info.kpsq_kh_name}
                            kpsq_kh_id={info.kpsq_kh_id}
                            kpsq_kh_fpxx_name={info.kpsq_khfpxx_name}
                            kpsq_kh_fpxx_id={info.kpsq_khfpxx_id}
                            kpsq_fp_file={info.kpsq_fp_file}
                            kpsq_fp_name={info.kpsq_fp_name}
                            kpsq_state={info.kpsq_state}
                        />
                         <FilePreview 
                            fileNames={info.kpsq_fp_file} 
                            fileUrls={info.kpsq_fp_name} 
                        />
                    </Col> 
                    {/* 第五行 */}
                    <Col span={24} className={classes.bottom_row}>
                        <InvoiceNodeCheck 
                            kpsq_id={props.kpsq_id} 
                            qy_id={props.qy_id} 
                            user_id={props.yh_id} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name} 
                            qy_name={props.qy_name}
                            kpsq_uname={info.kpsq_uname}
                            kpsq_ctime={info.kpsq_ctime}
                            kpsq_state_time={info.kpsq_state_time}
                        />
                    </Col>
                </Row> 
                <Row>
                    <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                        <DocumentRule/>
                        {(props.yh_id === props.kpsq_uid && props.kpsq_state ==='4') ? <Icon type='withdraw' onClick={() => {
                                                                                                // 如果正在提交中，直接返回
                                                                                                if (isSubmitting) {
                                                                                                    return;
                                                                                                }
                                                                                                
                                                                                                // 设置提交状态
                                                                                                setIsSubmitting(true);                                                                                                
                                                                                                ztxg({
                                                                                                    kpsq_id:props.kpsq_id,
                                                                                                    kpsq_state: '1',
                                                                                                }).then((res) => {
                                                                                                    if(res.data.Status === 'success') {
                                                                                                        message.success('团队报账单取消提交成功！')
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }else{
                                                                                                        message.error('团队报账单取消提交失败！'+res.data.Message)
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }
                                                                                                    // 3秒后恢复可点击状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                }).catch((err) => {
                                                                                                    // 出错时也要恢复状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                })
                                                                                            }} /> : null}
                        {yh_qx.includes('管理') ? <Space size={20}>
                            <InvoiceFinanceWithdraw kpsq_id={props.kpsq_id} kpsq_cw_content={info.kpsq_cw_content} kpsq_amount={info.kpsq_amount}/>
                            <InvoiceFinanceAmount kpsq_id={props.kpsq_id} kpsq_state={info.kpsq_state} kpsq_cw_content={info.kpsq_cw_content} kpsq_amount={info.kpsq_amount} />
                        </Space> : null}    
                    </Col>
                </Row>
                </div>
            </Modal>
        </>
    )
}

export default InvoiceCheck